const { createSelector } = require('reselect')
const selectServices = state => state['marketplace.services'].getServices

const getServices = () => createSelector(
  [selectServices],
  prof => prof.data,
)

const getServicesError = () => createSelector(
  [selectServices],
  prof => prof.error,
)

const getServicesLoading = () => createSelector(
  [selectServices],
  prof => prof.loading,
)

//packages

const selectPackages = state => state['marketplace.services'].packages

const packages = () => createSelector(
  [selectPackages],
  prof => prof.data,
)

const packagesError = () => createSelector(
  [selectPackages],
  prof => prof.error,
)

const packagesLoading = () => createSelector(
  [selectPackages],
  prof => prof.loading,
)

//catalogue

const selectCatalogue = state => state['marketplace.services'].catalogue

const catalogue = () => createSelector(
  [selectCatalogue],
  prof => prof.data,
)

const catalogueError = () => createSelector(
  [selectCatalogue],
  prof => prof.error,
)

const catalogueLoading = () => createSelector(
  [selectCatalogue],
  prof => prof.loading,
)

module.exports = {
  getServices,
  getServicesError,
  getServicesLoading,

  packages,
  packagesError,
  packagesLoading,

  catalogue,
  catalogueError,
  catalogueLoading

}
